<template>
  <v-row>
    <v-flex xs12 md4 lg3 pa-1>
      <v-col>
        <!-- Driver Header - avatar, summary stats, Current/Unpaid/All selector -->
        <v-card color="white" class="header">
          <v-layout
            v-if="!loadingDriverInfo"
            row
            align-center
            justify-start
            class="header"
          >
            <v-flex xs12 class="header" pa-1>
              <v-layout row>
                <v-flex shrink pl-1>
                  <v-layout column>
                    <v-card color="grey lighten-1" elevation="0">
                      <h5
                        class="nobold white--text text--lighten-1"
                        style="padding-right: 6px"
                      >
                        <b>&nbsp {{ driverInfo.user.name }}</b>
                      </h5>
                    </v-card>
                    <v-card
                      color="grey lighten-1"
                      elevation="0"
                      style="margin-top: 4px; padding-right: 6px"
                    >
                      <h5 class="nobold white--text text--lighten-1">
                        &nbsp {{ driverInfo.user.email }}
                      </h5>
                    </v-card>
                    <v-card
                      color="grey lighten-1"
                      elevation="0"
                      style="margin-top: 4px; padding-right: 6px"
                    >
                      <h5 class="nobold white--text text--lighten-1">
                        &nbsp {{ driverInfo.user.contact_number }}
                      </h5>
                    </v-card>
                  </v-layout>
                </v-flex>
                <v-divider class="mx-2" vertical></v-divider>
                <v-flex shrink>
                  <v-layout column>
                    <v-spacer></v-spacer>
                    <v-btn
                      x-small
                      :depressed="viewing == 'current'"
                      :color="
                        viewing == 'current'
                          ? 'primary white--text'
                          : 'white darken-1 grey--text text--darken-2'
                      "
                      class="text-none removeButtonPadding"
                      @click="switchToCurrent()"
                      >Current Invoice(s)</v-btn
                    >
                    <v-btn
                      x-small
                      :depressed="viewing == 'unpaid'"
                      :color="
                        viewing == 'unpaid'
                          ? 'primary white--text'
                          : 'white darken-1 grey--text text--darken-2'
                      "
                      class="text-none removeButtonPadding spacingForButton"
                      @click="switchToUnpaid()"
                      >Unpaid Invoices</v-btn
                    >
                    <v-btn
                      :depressed="viewing == 'all'"
                      :color="
                        viewing == 'all'
                          ? 'primary white--text'
                          : 'white darken-1 grey--text text--darken-2'
                      "
                      class="text-none removeButtonPadding spacingForButton"
                      @click="switchToAll()"
                      x-small
                      >All Invoices</v-btn
                    >
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
        <v-flex pt-2>
          <v-layout v-if="invoices" style="height: 95%">
            <v-flex xs12 pb-1 style="height: 95%">
              <!-- Invoices List -->
              <InvoiceList
                ref="invoiceList"
                :invoices="invoices"
                :unpaidTotals="unpaidTotals"
                :loading="loadingInvoices"
                :invoicesRows="invoicesRows"
                :numberPages="numberOfInvoicePages"
                :viewing="viewing"
                :invoiceRowRefreshID="invoiceRowRefreshID"
                :fullscreen="fullscreen"
                @markAsPaid="markAsPaid($event)"
                @markAllAsPaid="markAllAsPaid($event)"
                @loadInvoice="loadInvoice($event)"
                @closeInvoice="
                  invoiceDetails = null;
                  invoiceTimesheet = null;
                  fullscreen = true;
                "
                @changeSummaryRows="changeSummaryRows($event)"
                @getInvoices="getAllInvoices($event)"
                @search="searchInvoices($event)"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-col>
    </v-flex>
    <v-flex v-if="invoiceDetails" xs12 lg9 md8 px-1 pb-1 pt-1>
      <!-- Jobs/Extras Table -->
      <JobList
        :invoiceDetails="invoiceDetails"
        :loading="loadingInvoiceDetails"
        :currentInvoice="viewing == 'current'"
        :driverTable="true"
        :driver="driverInfo"
        @updatePaymentType="updatePaymentType($event)"
        @setFinalCost="setFinalCost($event)"
        @setDriverPay="setDriverPay($event)"
        @setCommission="setCommission($event)"
        @resetCommission="resetCommission($event)"
        @addExtra="addExtra($event)"
        @removeExtra="removeExtra($event)"
        @sendInvoice="sendInvoice($event)"
        @errorSnackbar="showSnackbar($event, 'error')"
        @markAsPaid="markAsPaid($event)"
        @startClearInvoice="startClearInvoice($event)"
        @commissionChanged="commissionChanged"
      />
    </v-flex>
    <v-snackbar v-model="snackbarShow" :color="snackbarColour" :timeout="4000">
      <v-layout align-center justify-center>{{ snackbarMessage }}</v-layout>
    </v-snackbar>
  </v-row>
</template>

<script>
import InvoiceList from "@/components/invoices/InvoiceList.vue";
import JobList from "@/components/invoices/JobList.vue";
import InvoiceSummary from "@/components/invoices/InvoiceSummary.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "driver_invoices",
  components: {
    InvoiceList,
    JobList,
    InvoiceSummary,
  },
  data: function () {
    return {
      viewing: "current",
      loadingDriverInfo: true,
      driverInfo: null,
      loadingInvoices: false,
      invoices: null,
      loadingInvoiceDetails: false,
      unpaidTotals: null,
      invoiceTimesheet: null,
      loadingInvoiceTimesheetDetails: false,
      invoiceRowRefreshID: -1,
      numberOfInvoicePages: -1,
      currentOffset: 0,
      invoicesRows: -1,
      invoiceDetails: null,
      submittedSearch: {
        query: "",
        startDate: "",
        endDate: "",
      },
      snackbarShow: false,
      snackbarColour: null,
      snackbarMessage: null,
      fullscreen: true,
    };
  },
  beforeMount: function () {
    if (!this.$cookies.isKey("invoicesRows")) {
      this.$cookies.set("invoicesRows", 10, Infinity);
    }
    this.invoicesRows = parseInt(this.$cookies.get("invoicesRows"));
  },
  mounted: function () {
    let self = this;
    Promise.all([this.getDriverInfo(), this.getCurrentInvoices()]).then(
      function (success) {
        if (!success[0] || !success[1]) {
        }
      }
    );
  },
  methods: {
    startClearInvoice: function (event) {
      this.$refs.invoiceList.startClearInvoice(event);
    },
    getDriverInfo: async function () {
      this.driverInfo = {};
      let url = `${this.$store.state.apiUrl}/driver/${this.$route.params.id}/get`;

      try {
        const response = await axios.get(url);

        if (!response.data.id) {
          console.log(response.data);
          this.loadingDriverInfo = false;
          return false;
        } else {
          this.driverInfo = {
            ...response.data,
            picture: response.data.pictureURL,
          };

          this.driverInfo.sortCode = this.driverInfo.driver_details.sortCode;
          this.driverInfo.accountNumber = this.driverInfo.driver_details.accountNumber;
          this.loadingDriverInfo = false;
          return true;
        }
      } catch (error) {
        console.log(error);
        this.loadingDriverInfo = false;
        return false;
      }
    },
    getUnpaidInvoices: async function () {
      this.invoices = [];
      let url = `${this.$store.state.apiUrl}/invoice/driver/unpaidSummaryForDriver?driver_id=${this.$route.params.id}`;

      try {
        const response = await axios.get(url);

        if (response.data.error != "no_error") {
          console.log(response.data.error);
          return false;
        } else {
          this.invoices = response.data.unpaid_invoices;
          return true;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },
    getUnpaidDriverTotals: async function () {
      this.unpaidTotals = {};
      let url = `${this.$store.state.apiUrl}/invoice/driver/totalsUnpaidForDriver?driver_id=${this.$route.params.id}`;

      try {
        const response = await axios.get(url);

        if (response.data.error != "no_error") {
          console.log(response.data.error);
          return false;
        } else {
          this.unpaidTotals = response.data.totals;
          return true;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },
    getUnpaid: async function () {
      let self = this;
      this.loadingInvoices = true;
      Promise.all([
        this.getUnpaidInvoices(),
        this.getUnpaidDriverTotals(),
      ]).then(function (success) {
        if (!success[0] || !success[1]) {
        }
        self.loadingInvoices = false;
      });
    },
    getAllInvoices: async function (offset) {
      this.invoices = [];
      this.loadingInvoices = true;
      this.currentOffset = offset;
      let url = `${this.$store.state.apiUrl}/invoice/driver/allProcessedSummaryForDriver?driver_id=${this.$route.params.id}&offset=${offset}&count=${this.invoicesRows}`;

      if (
        this.submittedSearch.query &&
        this.submittedSearch.query.trim() != ""
      ) {
        url += `&query=${this.submittedSearch.query}`;
      }
      if (
        this.submittedSearch.startDate &&
        this.submittedSearch.startDate.trim() != ""
      ) {
        url += `&start_date=${this.submittedSearch.startDate}`;
      }
      if (
        this.submittedSearch.endDate &&
        this.submittedSearch.endDate.trim() != ""
      ) {
        url += `&end_date=${this.submittedSearch.endDate}`;
      }

      try {
        const response = await axios.get(url);

        if (response.data.error != "no_error") {
          console.log(response.data.error);
          this.loadingInvoices = false;
          return false;
        } else {
          this.numberOfInvoicePages = response.data.num_pages;
          this.invoices = response.data.invoices;
          this.loadingInvoices = false;
          return true;
        }
      } catch (error) {
        console.log(error);
        this.loadingInvoices = false;
        return false;
      }
    },
    getCurrentInvoices: async function () {
      this.invoices = [];
      this.loadingInvoices = true;

      let url = `${this.$store.state.apiUrl}/invoice/driver/unprocessedSummaryForDriver?driver_id=${this.$route.params.id}`;

      try {
        const response = await axios.get(url);

        if (response.data.error != "no_error") {
          console.log(response.data.error);
          this.loadingInvoices = false;
          return false;
        } else {
          this.numberOfInvoicePages = 1;
          this.invoices = response.data.unprocessed_invoices;
          this.loadingInvoices = false;
          return true;
        }
      } catch (error) {
        console.log(error);
        this.loadingInvoices = false;
        return false;
      }
    },
    getInvoiceDetails: async function (invoiceID) {
      this.invoiceDetails = {};
      this.loadingInvoiceDetails = true;
      let url = `${this.$store.state.apiUrl}/invoice/driver/get?invoice_id=${invoiceID}`;

      try {
        const response = await axios.get(url);

        if (response.data.error != "no_error") {
          console.log(response.data.error);
          return false;
        } else {
          this.invoiceDetails = {
            driver: null,
            invoice: response.data.invoice,
          };
          return true;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },
    getTimesheetDetails: async function (invoiceID) {
      console.log("getting timesheet details");
      this.invoiceTimesheet = null;
      this.loadingInvoiceTimesheetDetails = true;
      let url = `${this.$store.state.apiUrl}/invoice/driver/getTimesheet?invoice_id=${invoiceID}`;

      try {
        const response = await axios.get(url);

        if (response.data.error != "no_error") {
          console.log(response.data.error);
          return false;
        } else {
          console.log(response.data.timesheet);
          this.invoiceTimesheet = response.data.timesheet;
          return true;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },
    commissionChanged: function (a, b, invoice) {
      this.updateInvoiceRowSummary(invoice);
      this.$set(this.invoiceDetails, "invoice", invoice);

      if (this.viewing == "unpaid") {
        this.getUnpaidDriverTotals();
      } else if (this.viewing == "all") {
        this.getAllInvoices(this.currentOffset);
      }
    },
    markAsPaid: function (invoice) {
      console.log("clearing an invoice");
      let self = this;
      let url = `${this.$store.state.apiUrl}/invoice/driver/markAsPaid`;
      axios({
        url: url,
        method: "POST",
        params: {
          invoice_id: invoice.invoiceID,
          notes: invoice.notes,
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error != "no_error") {
            self.showSnackbar("Failed to mark invoice as paid", "error");
          } else {
            self.showSnackbar("Invoice marked as paid", "success");

            if (
              self.viewing == "unpaid" &&
              self.invoiceDetails &&
              self.invoiceDetails.invoice.id == invoice.invoiceID
            ) {
              self.invoiceDetails = null;
              self.fullscreen = true;
            }

            if (self.viewing == "unpaid") {
              let newInvoices = self.invoices.filter((filterInvoice) => {
                return filterInvoice.id != invoice.invoiceID;
              });
              self.invoices = newInvoices;
              self.getUnpaidDriverTotals();
            } else if (self.viewing == "all") {
              self.getAllInvoices(self.currentOffset);
            }

            alert("Invoice Payment Code " + res.data.code);
          }
        })
        .catch(function (err) {
          console.log(err);
          self.showSnackbar("Failed to mark invoice as paid", "error");
        });
    },
    markAllAsPaid: function (notes) {
      console.log("clearing an account");
      let self = this;
      let url = `${this.$store.state.apiUrl}/invoice/driver/markAllAsPaid`;
      axios({
        url: url,
        method: "POST",
        params: {
          driver_id: this.$route.params.id,
          notes: notes,
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error != "no_error") {
            self.showSnackbar("Failed to mark invoices as paid", "error");
          } else {
            self.showSnackbar("All invoices marked as paid", "success");

            //Can only be triggered all from unpaid so always refresh unpaid and clear details
            self.invoiceDetails = null;
            self.fullscreen = true;
            self.getUnpaid();

            alert("Invoice Payment Code " + res.data.code);
          }
        })
        .catch(function (err) {
          console.log(err);
          self.showSnackbar("Failed to mark invoicse as paid", "error");
        });
    },
    loadInvoice: function (invoiceID) {
      let self = this;

      Promise.all([
        this.getInvoiceDetails(invoiceID),
        this.getTimesheetDetails(invoiceID),
      ]).then(function (success) {
        if (success[0]) {
          self.loadingInvoiceDetails = false;
          self.fullscreen = false;
        }
        if (success[0] && success[1]) {
          self.loadingInvoiceTimesheetDetails = false;
          self.fullscreen = false;
        }
      });
    },
    updatePaymentType: function (data) {
      console.log("updating payment type");
      this.invoiceRowRefreshID = this.invoiceDetails.invoice.id;
      let self = this;
      let bookingID = data.bookingID;
      let url = `${this.$store.state.apiUrl}/invoice/driver/changePaymentType?booking_id=${bookingID}&payment_type=${data.paymentType}`;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error != "no_error") {
            self.showSnackbar("Failed to set set payment type", "error");
          } else {
            self.showSnackbar("Successfully set payment type", "success");
            self.$set(self.invoiceDetails, "invoice", res.data.invoice);
            self.updateInvoiceRowSummary(res.data.invoice);

            self.getUnpaidDriverTotals();
          }
        })
        .catch(function (err) {
          console.log(err);
          self.showSnackbar("Failed to set payment type", "error");
        });
    },
    setFinalCost: function (data) {
      console.log("setting final cost");
      this.invoiceRowRefreshID = this.invoiceDetails.invoice.id;
      let self = this;
      let bookingID = data.bookingID;
      let amount = Math.round(data.amount * 100);
      let url = `${this.$store.state.apiUrl}/invoice/driver/setBookingFinalCost?booking_id=${bookingID}&amount=${amount}`;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error != "no_error") {
            self.showSnackbar("Failed to set final cost", "error");
          } else {
            self.showSnackbar("Successfully set final cost", "success");
            self.$set(self.invoiceDetails, "invoice", res.data.invoice);
            self.updateInvoiceRowSummary(res.data.invoice);
            self.getUnpaidDriverTotals();
          }
        })
        .catch(function (err) {
          console.log(err);
          self.showSnackbar("Failed to set final cost", "error");
        });
    },
    setDriverPay: function (data) {
      console.log("setting driver pay");
      this.invoiceRowRefreshID = this.invoiceDetails.invoice.id;
      let self = this;
      let bookingID = data.bookingID;
      let amount = Math.round(data.amount * 100);
      let url = `${this.$store.state.apiUrl}/invoice/driver/manuallySetDriverPay?booking_id=${bookingID}&amount=${amount}`;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error != "no_error") {
            self.showSnackbar("Failed to set driver pay", "error");
          } else {
            self.showSnackbar("Successfully set driver pay", "success");
            self.$set(self.invoiceDetails, "invoice", res.data.invoice);
            self.updateInvoiceRowSummary(res.data.invoice);
            self.getUnpaidDriverTotals();
          }
        })
        .catch(function (err) {
          console.log(err);
          self.showSnackbar("Failed to set driver pay", "error");
        });
    },
    setCommission: function (data) {
      console.log("setting commssion");
      this.invoiceRowRefreshID = this.invoiceDetails.invoice.id;
      let self = this;
      let bookingID = data.bookingID;
      let amount = Math.round(data.amount * 100);
      let url = `${this.$store.state.apiUrl}/invoice/driver/manuallySetCharge?booking_id=${bookingID}&amount=${amount}`;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error != "no_error") {
            self.showSnackbar("Failed to set commission", "error");
          } else {
            self.showSnackbar("Successfully set commission", "success");
            self.$set(self.invoiceDetails, "invoice", res.data.invoice);
            self.updateInvoiceRowSummary(res.data.invoice);
            self.getUnpaidDriverTotals();
          }
        })
        .catch(function (err) {
          console.log(err);
          self.showSnackbar("Failed to set commission", "error");
        });
    },
    resetCommission: function (bookingID) {
      console.log("resetting commssion");
      this.invoiceRowRefreshID = this.invoiceDetails.invoice.id;
      let self = this;
      let url = `${this.$store.state.apiUrl}/invoice/driver/resetCharge?booking_id=${bookingID}`;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error != "no_error") {
            self.showSnackbar("Failed to reset commission", "error");
          } else {
            self.showSnackbar("Successfully reset commission", "success");
            self.$set(self.invoiceDetails, "invoice", res.data.invoice);
            self.updateInvoiceRowSummary(res.data.invoice);
            self.getUnpaidDriverTotals();
          }
        })
        .catch(function (err) {
          console.log(err);
          self.showSnackbar("Failed to reset commission", "error");
        });
    },
    addExtra: function (extra) {
      console.log("adding extra");
      this.invoiceRowRefreshID = this.invoiceDetails.invoice.id;
      console.log(this.invoiceDetails.invoice.id);
      let self = this;
      let url = `${this.$store.state.apiUrl}/invoice/driver/addExtra`;
      extra.amount = Math.round(extra.amount * 100);
      axios({
        url: url,
        method: "POST",
        params: extra,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error != "no_error") {
            self.showSnackbar(
              "Failed to add extra: " + res.data.message,
              "error"
            );
          } else {
            self.showSnackbar("Successfully added extra", "success");
            self.$set(self.invoiceDetails, "invoice", res.data.invoice);
            self.updateInvoiceRowSummary(res.data.invoice);
            self.getUnpaidDriverTotals();
          }
        })
        .catch(function (err) {
          console.log(err);
          self.showSnackbar("Failed to add extra", "error");
        });
    },
    removeExtra: function (extraID) {
      console.log("removing extra");
      this.invoiceRowRefreshID = this.invoiceDetails.invoice.id;
      let self = this;
      let url = `${this.$store.state.apiUrl}/invoice/driver/removeExtra/?extra_id=${extraID}`;
      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error != "no_error") {
            self.showSnackbar(
              "Failed to remove extra: " + res.data.message,
              "error"
            );
          } else {
            self.showSnackbar("Successfully removed extra", "success");
            self.$set(self.invoiceDetails, "invoice", res.data.invoice);
            self.updateInvoiceRowSummary(res.data.invoice);
            self.getUnpaidDriverTotals();
          }
        })
        .catch(function (err) {
          console.log(err);
          self.showSnackbar("Failed to remove extra", "error");
        });
    },
    sendInvoice: function (invoiceID) {
      console.log("sending invoice");
      let self = this;
      let url = `${this.$store.state.apiUrl}/invoice/driver/sendInvoice/?invoice_id=${invoiceID}`;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error != "no_error") {
            self.showSnackbar(
              "Failed to send invoice: " + res.data.message,
              "error"
            );
          } else {
            self.showSnackbar("Successfully sent invoice", "success");
            self.getCurrentInvoices();
            self.invoiceDetails = null;
          }
        })
        .catch(function (err) {
          console.log(err);
          self.showSnackbar("Failed to send invoice", "error");
        });
    },
    updateInvoiceRowSummary: function (invoice) {
      console.log("updating invoice row");
      let invoiceRow = {
        date: invoice.date,
        created_time: invoice.created_time,
        id: invoice.id,
        paid: invoice.paid,
        sent: invoice.sent,
        totals: invoice.totals,
      };
      if (invoice.paid_time) {
        invoiceRow.paid_time = invoice.paid_time;
      }

      if (this.invoices) {
        for (let i = 0; i < this.invoices.length; i++) {
          if (this.invoices[i].id == invoice.id) {
            this.$set(this.invoices, i, invoiceRow);
          }
        }
      }

      this.invoiceRowRefreshID = -1;
    },
    showSnackbar: function (message, colour) {
      this.snackbarMessage = message;
      this.snackbarColour = colour;
      this.snackbarShow = true;
    },
    changeSummaryRows: function (rows) {
      this.$cookies.set("invoicesRows", rows, Infinity);
      this.invoicesRows = parseInt(this.$cookies.get("invoicesRows"));
      this.getAllInvoices(0);
    },
    switchToCurrent: function () {
      this.reset();
      this.viewing = "current";
      this.getCurrentInvoices();
    },
    switchToUnpaid: function () {
      this.reset();
      this.viewing = "unpaid";
      this.getUnpaid();
    },
    switchToAll: function () {
      this.reset();
      this.viewing = "all";
      this.getAllInvoices(0);
    },
    reset: function () {
      this.invoices = null;
      this.unpaidTotals = null;
      this.invoiceDetails = null;
      this.invoiceTimesheet = null;
      this.fullscreen = true;
      this.numberOfInvoicePages = -1;
      this.submittedSearch = {
        query: "",
        startDate: "",
        endDate: "",
      };
    },
    searchInvoices: function (search) {
      this.submittedSearch = search;
      this.invoices = null;
      this.invoiceDetails = null;
      this.invoiceTimesheet = null;
      this.fullscreen = true;
      this.numberOfInvoicePages = -1;
      this.getAllInvoices(0);
    },
  },
  computed: {
    invoiceListColumns: function () {
      if (this.fullscreen) {
        return 12;
      } else {
        return 9;
      }
    },
  },
};
</script>

<style>
.nobold {
  font-weight: normal;
}

.header {
  max-height: 80px;
}

.removeButtonPadding {
  min-width: 0 !important;
  padding-right: 3px !important;
  padding-left: 3px !important;
  margin: 0 !important;
  border-radius: 0;
  height: 20px !important;
}

.spacingForButton {
  margin-top: 4px !important;
}

.col {
  padding: 0px 8px !important;
}
</style>